









import * as CurrentTimeFactory from '@/models/current-time/functions'
import { SubscriptionApplyingItem } from '@/models/order/subscription/applying-item/subscription-applying-item'
import { format } from 'date-fns'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

const datePrintFormat = 'YYYY/MM/DD'

@Component
export default class NoteSubscriptionRange extends Vue {
  @Prop({ required: true })
  readonly applyingItem: SubscriptionApplyingItem

  get range() {
    return this.applyingItem.config.range
  }

  get current(): string {
    return format(CurrentTimeFactory.create().now, datePrintFormat)
  }

  get cancelableRange(): { begin: string, end: string } {
    const range = this.applyingItem.cancel.cancellableRange

    return {
      begin: format(range.begin, datePrintFormat),
      end: format(range.end, datePrintFormat),
    }
  }
}
